import actions from './actions'
import mutations from './mutations'
import { parseJSON } from '@/utils/helpers'

const app = {
	state: {
		order: parseJSON(localStorage.order),
		messages: [],
		tariffs: [],
		options: [],
		reverseIndex: null,
		reverseData: null
	},
	mutations,
	actions
}

export default app
